import { render } from "./view_topic.html?vue&type=template&id=b00fca4c&external"
import script from "./view_topic.js?vue&type=script&lang=js&external"
export * from "./view_topic.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__